import React from 'react';
import { Modal, Box, CircularProgress } from '@mui/material';

interface SpinnerModalProps {
  open: boolean;
}

const SpinnerModal: React.FC<SpinnerModalProps> = ({ open }) => {
  return (
    <Modal open={open} aria-labelledby="loading-modal" aria-describedby="loading-indicator">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress size={80} />
      </Box>
    </Modal>
  );
};

export default SpinnerModal;
